import {circInOut} from '../config/easing';
import {DEFAULT_EASING} from '../../constants';

export const DEFAULT_TRANSITION = {
	ease: DEFAULT_EASING,
	duration: 0.25,
};

export const fadeInOut = (level = 1) => {
    return {
        initial: {
            opacity: 0,
        },
        animate: {
            opacity: level,
            transition: {
                ...circInOut,
            },
        },
        exit: {
            opacity: 0,
            transition: {
                ...circInOut,
            },
        },
    };
};

export const slideInOut = {
    initial: {
        y: 20,
        opacity: 0,
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            ...circInOut,
        },
    },
    exit: {
        y: 20,
        opacity: 0,
        transition: {
            ...circInOut,
        },
    },
};
